export default {
  timeReg: (date) => {
    // 时间戳转化成标准格式
    // console.log(timeReg(1477808630404))
    // '2016-10-30 14:23:50
    const now = new Date(date)
    const y = now.getFullYear()
    const m = now.getMonth() + 1
    const d = now.getDate()
    return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d) + ' ' + now.toTimeString().substr(0, 8)
  },
  fmtDate: (obj) => {
    // 北京时间转化成标准格式的 年月日
    // console.log(fmtDate("2018-04-25T07:30:18.140Z"))
    // '2018-04-25'
    const date = new Date(obj)
    const y = 1900 + date.getYear()
    const m = '0' + (date.getMonth() + 1)
    const d = '0' + date.getDate()
    return y + '-' + m.substring(m.length - 2, m.length) + '-' + d.substring(d.length - 2, d.length)
  },
  getNowFormatDate: (obj) => {
    // 北京时间转化成标准格式的 年月日时分秒
    // console.log(getNowFormatDate("2018-04-25T07:30:18.140Z"))
    // '2018-04-25 15:30:18'
    var date = new Date(obj)
    var seperator1 = '-'
    var seperator2 = ':'
    var month = date.getMonth() + 1
    var strDate = date.getDate()
    if (month >= 1 && month <= 9) {
      month = '0' + month
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = '0' + strDate
    }
    var minuts = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate + ' ' + date.getHours() + seperator2 + minuts + seperator2 + date.getSeconds()
    return currentdate
  },
  formatDateTime: (date) => {
    // 中国标准时间转化成标准格式的 年月日时分秒
    // console.log(formatDateTime("Fri Jul 20 2018 15:26:05 GMT+0800 (中国标准时间)"))
    // '2018-07-20 15:26:18'
    var y = date.getFullYear()
    var m = date.getMonth() + 1
    m = m < 10 ? ('0' + m) : m
    var d = date.getDate()
    d = d < 10 ? ('0' + d) : d
    var h = date.getHours()
    var minute = date.getMinutes()
    var second = date.getSeconds()
    h = h < 10 ? ('0' + h) : h
    minute = minute < 10 ? ('0' + minute) : minute
    second = second < 10 ? ('0' + second) : second
    return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
  },
  formatDate: (date) => {
    // 中国标准时间转化成标准格式的 年月日
    // console.log(formatDate("Fri Jul 20 2018 15:26:05 GMT+0800 (中国标准时间)"))
    // '2018-07-20'
    var y = date.getFullYear()
    var m = date.getMonth() + 1
    m = m < 10 ? ('0' + m) : m
    var d = date.getDate()
    d = d < 10 ? ('0' + d) : d
    return y + '-' + m + '-' + d
  },
  formatTime: (date) => {
    // 中国标准时间转化成标准格式的 年月日时分秒
    // console.log(formatTime("Fri Jul 20 2018 15:26:05 GMT+0800 (中国标准时间)"))
    // '2018-07-20 15:26:18'
    var h = date.getHours()
    var minute = date.getMinutes()
    minute = minute < 10 ? ('0' + minute) : minute
    return h + ':' + minute
  },
  formatMonth: (date) => {
    // 中国标准时间转化成标准格式的 年月
    // console.log(formatDate("Fri Jul 20 2018 15:26:05 GMT+0800 (中国标准时间)"))
    // '2018-07'
    var y = date.getFullYear()
    var m = date.getMonth() + 1
    m = m < 10 ? ('0' + m) : m
    return y + '-' + m
  },

  //获取指定年份月份的最后一天
  getMonthFinalDay: (year,month)=> {
    var day='';
    if(year==null || year==undefined || year==''){
        year = new Date().getFullYear();
    }
    if(month==null ||  month==undefined || month==''){
        month = new Date().getMonth()+1;
    }
    day = new Date(new Date(year,month).setDate(0)).getDate();
    return year+"-"+month+"-"+day;   
  },
  //日期是30天前到今天的对应日期范围
  getthirty:() =>{
    let nowDate = new Date()
    var y1 = nowDate.getFullYear()
    var m1 = nowDate.getMonth() + 1
    m1 = m1 < 10 ? ('0' + m1) : m1
    var d1 = nowDate.getDate()
    d1 = d1 < 10 ? ('0' + d1) : d1
    let end = y1 + '-' + m1 + '-' + d1+' '+'23:59:59'
    var day_30 = new Date().setMonth((new Date().getMonth()-1));    //日期是30天前的对应时间戳
    day_30 = new Date(day_30);       //转换成标准时间
    var y = day_30.getFullYear();    //年
    var m = day_30.getMonth() +1;    //月
    var d = day_30.getDate();         //日
    if(m<10){
        m = '0'+m;
    }
    if(d<10){
        d = '0'+d;
    }
    // return  y+'-'+m+'-'+d+' '+'00:00:00';　　　　//日期是30天前的对应字符串 xxxx-xx-xx　
    let start = y+'-'+m+'-'+d+' '+'00:00:00';
    return [start,end]
  },
  //日期是30天前到今天的对应日期范围没有时分秒
  getthirtyno:() =>{
    let nowDate = new Date()
    var y1 = nowDate.getFullYear()
    var m1 = nowDate.getMonth() + 1
    m1 = m1 < 10 ? ('0' + m1) : m1
    var d1 = nowDate.getDate()
    d1 = d1 < 10 ? ('0' + d1) : d1
    let end = y1 + '-' + m1 + '-' + d1
    var day_30 = new Date().setMonth((new Date().getMonth()-1));    //日期是30天前的对应时间戳
    day_30 = new Date(day_30);       //转换成标准时间
    var y = day_30.getFullYear();    //年
    var m = day_30.getMonth() +1;    //月
    var d = day_30.getDate();         //日
    if(m<10){
        m = '0'+m;
    }
    if(d<10){
        d = '0'+d;
    }
    // return  y+'-'+m+'-'+d+' '+'00:00:00';　　　　//日期是30天前的对应字符串 xxxx-xx-xx　
    let start = y+'-'+m+'-'+d
    return [start,end]
  }
}
